export default __webpack_public_path__ + "static/media/auth-verify-success-3.effad7f6.png";